export default __webpack_public_path__ + "static/welcome-8635749f88e5f901a6b5c88b8050c492.png";